import { render, staticRenderFns } from "./StockQuantities.vue?vue&type=template&id=6943894a"
import script from "./StockQuantities.vue?vue&type=script&lang=js"
export * from "./StockQuantities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports